module.exports = __webpack_public_path__ + "26d42b3102c0b33d4f8a694e26a2ecc2.png";